import { schema } from 'normalizr'

export const eventSchema = new schema.Entity(
    'events',
    {},
    { idAttribute: 'id' }
)

export const bizNumbersSchema = new schema.Entity('numbers')

export const templatesSchema = new schema.Entity('templates')

export const contactsSchema = new schema.Entity('contacts')

export const colorsSchema = new schema.Entity('colors')

export const payrollDefaultWorkHourSchema = new schema.Entity(
    'payrollDefaultWorkHour',
    {},
    { idAttribute: 'PayrollEmpDefaultWorkHourEmployeeID' }
)

export const payrollNormalWorkHourSchema = new schema.Entity(
    'payrollNormalWorkHour',
    {},
    { idAttribute: 'PayrollEmpNormalWorkingHourEmployeeID' }
)

export const leaveSchema = new schema.Entity(
    'leaves',
    {},
    { idAttribute: 'id' }
)
